import axios from "axios";

const WOO_PRODUCTS_FETCH_PAGE_SIZE = 100;

export async function fetchAllWooProductsForSite(siteId, userId) {
  if (!siteId || !userId) {
    return {
      products: [],
      meta: {
        count: 0,
        total: 0,
        totalPages: 0,
        fetchedAll: false,
        source: "",
      },
    };
  }

  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/api/wordpress/products/${siteId}`,
    {
      params: {
        userId,
        perPage: WOO_PRODUCTS_FETCH_PAGE_SIZE,
        fetchAll: true,
      },
    }
  );

  const products = Array.isArray(response.data?.data) ? response.data.data : [];
  const meta = response.data?.meta || {};

  return {
    products,
    meta: {
      count: meta.count ?? products.length,
      total: meta.total ?? products.length,
      totalPages: meta.totalPages ?? null,
      fetchedAll: Boolean(meta.fetchedAll),
      source: meta.source || "",
    },
  };
}
